import buildUrl from 'build-url'

export default (options) => {
  if (window && window.location && window.location.host) {
    window.history.pushState('', '', buildUrl('/', options))
  }
}
